export var BUTTON_SIZES_BY_RESOLUTION = {
  mobile: 's',
  tablet: 'm',
  desktop: 'l'
};